/** A plain email address: something@something.tld, no spaces and no scheme. */
const EMAIL_PATTERN = /^[^\s@:/]+@[^\s@:/]+\.[^\s@:/]+$/;
const HTTP_PATTERN = /^https?:\/\//i;

/**
 * An http(s) URL that is safe to use as an `href`, or null.
 *
 * Used for every partner-supplied link (claim link, website, LinkedIn, video):
 * anything that is not http(s) - `javascript:`, `data:`, plain text - is refused,
 * so a free-form value can never become a hazardous link.
 *
 * @param url - the stored value
 */
export function safeWebHref(url: string | null | undefined): string | null {
  const value = url?.trim();
  return value && HTTP_PATTERN.test(value) ? value : null;
}

/**
 * A `mailto:` href for a claim email, or null when the value is not a plain email
 * address.
 *
 * @param email - the stored Email claim method (FR-114)
 */
export function claimMailtoHref(email: string | null | undefined): string | null {
  const value = email?.trim();
  return value && EMAIL_PATTERN.test(value) ? `mailto:${value}` : null;
}
